module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 519,
	"w": 320,
	"h": 276,
	"nm": "Timeline - mobile",
	"ddd": 0,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 0,
					"nm": "2011",
					"refId": "comp_1",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"w": 276,
					"h": 276,
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 0,
					"nm": "2015",
					"refId": "comp_2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								444,
								138,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"w": 276,
					"h": 276,
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 0,
					"nm": "2016",
					"refId": "comp_3",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								750,
								138,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"w": 276,
					"h": 276,
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 0,
					"nm": "2017",
					"refId": "comp_4",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1056,
								138,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"w": 276,
					"h": 276,
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 0,
					"nm": "2018",
					"refId": "comp_5",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1362,
								138,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"w": 276,
					"h": 276,
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 6,
					"ty": 0,
					"nm": "2019",
					"refId": "comp_6",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1668,
								138,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"w": 276,
					"h": 276,
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 7,
					"ty": 0,
					"nm": "2020",
					"refId": "comp_7",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								1974,
								138,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"w": 276,
					"h": 276,
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 8,
					"ty": 0,
					"nm": "2021",
					"refId": "comp_8",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								2280,
								138,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"w": 276,
					"h": 276,
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 9,
					"ty": 0,
					"nm": "2022",
					"refId": "comp_9",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								2586,
								138,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								138,
								138,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"w": 276,
					"h": 276,
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_1",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 5,
					"nm": "First concept design of the Spotin service",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.145,
								137.534,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-58,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"sz": [
											180,
											146.5
										],
										"ps": [
											-90,
											-73.25
										],
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "First concept design of the Spotin service",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -8,
					"op": 610,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Höger ram 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"s": true,
							"x": {
								"a": 0,
								"k": 138,
								"ix": 3
							},
							"y": {
								"a": 0,
								"k": 138,
								"ix": 4
							}
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								76.427,
								76.427,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											356.336,
											356.336
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019607843,
											0.941176470588,
											0.890196078431,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"bm": 0,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": -3,
					"op": 614,
					"st": 1,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "2011",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 0,
									"s": [
										179
									]
								},
								{
									"t": 599,
									"s": [
										0
									]
								}
							],
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.023,
								138.085,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-3,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								55.865,
								55.865,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "n",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										],
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										]
									],
									"o": [
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										],
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										]
									],
									"v": [
										[
											-0.121,
											-184.085
										],
										[
											-180.023,
											-4.182
										],
										[
											-0.121,
											175.72
										],
										[
											179.782,
											-4.182
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 67,
										"f": "LabilGrotesk-Bold",
										"t": "2011",
										"j": 2,
										"tr": 0,
										"lh": 80.4,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {
							"m": 0,
							"f": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"l": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"a": 0,
							"p": 1,
							"r": 1
						},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -4,
					"op": 653,
					"st": 0,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_2",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 5,
					"nm": "<empty text layer>",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								453,
								73,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "Founded as Context Sales Sweden",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.145,
								129.947,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-58,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"sz": [
											142,
											146.5
										],
										"ps": [
											-71,
											-73.25
										],
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "Founded as Context Sales Sweden",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -8,
					"op": 610,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "2015",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 0,
									"s": [
										199
									]
								},
								{
									"t": 599,
									"s": [
										20
									]
								}
							],
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.023,
								138.085,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-3,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								55.865,
								55.865,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "n",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										],
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										]
									],
									"o": [
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										],
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										]
									],
									"v": [
										[
											-0.121,
											-184.085
										],
										[
											-180.023,
											-4.182
										],
										[
											-0.121,
											175.72
										],
										[
											179.782,
											-4.182
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 67,
										"f": "LabilGrotesk-Bold",
										"t": "2015",
										"j": 2,
										"tr": 0,
										"lh": 80.4,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {
							"m": 0,
							"f": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"l": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"a": 0,
							"p": 1,
							"r": 1
						},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -4,
					"op": 653,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "Höger ram 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"s": true,
							"x": {
								"a": 0,
								"k": 138,
								"ix": 3
							},
							"y": {
								"a": 0,
								"k": 138,
								"ix": 4
							}
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								76.427,
								76.427,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											356.336,
											356.336
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019607843,
											0.941176470588,
											0.890196078431,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"bm": 0,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": -3,
					"op": 614,
					"st": 1,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_3",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 5,
					"nm": "<empty text layer>",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								453,
								73,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "Founded as Context Sales Sweden",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.145,
								129.947,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-58,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"sz": [
											142,
											146.5
										],
										"ps": [
											-71,
											-73.25
										],
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "Founded as Context Sales Sweden",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -8,
					"op": 610,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "2016",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 0,
									"s": [
										219
									]
								},
								{
									"t": 599,
									"s": [
										40
									]
								}
							],
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.023,
								138.085,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-3,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								55.865,
								55.865,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "n",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										],
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										]
									],
									"o": [
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										],
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										]
									],
									"v": [
										[
											-0.121,
											-184.085
										],
										[
											-180.023,
											-4.182
										],
										[
											-0.121,
											175.72
										],
										[
											179.782,
											-4.182
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 67,
										"f": "LabilGrotesk-Bold",
										"t": "2016",
										"j": 2,
										"tr": 0,
										"lh": 80.4,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {
							"m": 0,
							"f": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"l": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"a": 0,
							"p": 1,
							"r": 1
						},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -4,
					"op": 653,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "Höger ram 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"s": true,
							"x": {
								"a": 0,
								"k": 138,
								"ix": 3
							},
							"y": {
								"a": 0,
								"k": 138,
								"ix": 4
							}
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								76.427,
								76.427,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											356.336,
											356.336
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019607843,
											0.941176470588,
											0.890196078431,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"bm": 0,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": -3,
					"op": 614,
					"st": 1,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_4",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 5,
					"nm": "<empty text layer>",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								453,
								73,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "Founded as Context Sales Sweden",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.145,
								129.947,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-58,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"sz": [
											142,
											146.5
										],
										"ps": [
											-71,
											-73.25
										],
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "Founded as Context Sales Sweden",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -8,
					"op": 610,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "2017",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 0,
									"s": [
										239
									]
								},
								{
									"t": 599,
									"s": [
										60
									]
								}
							],
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.023,
								138.085,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-3,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								55.865,
								55.865,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "n",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										],
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										]
									],
									"o": [
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										],
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										]
									],
									"v": [
										[
											-0.121,
											-184.085
										],
										[
											-180.023,
											-4.182
										],
										[
											-0.121,
											175.72
										],
										[
											179.782,
											-4.182
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 67,
										"f": "LabilGrotesk-Bold",
										"t": "2017",
										"j": 2,
										"tr": 0,
										"lh": 80.4,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {
							"m": 0,
							"f": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"l": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"a": 0,
							"p": 1,
							"r": 1
						},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -4,
					"op": 653,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "Höger ram 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"s": true,
							"x": {
								"a": 0,
								"k": 138,
								"ix": 3
							},
							"y": {
								"a": 0,
								"k": 138,
								"ix": 4
							}
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								76.427,
								76.427,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											356.336,
											356.336
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019607843,
											0.941176470588,
											0.890196078431,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"bm": 0,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": -3,
					"op": 614,
					"st": 1,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_5",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 5,
					"nm": "<empty text layer>",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								453,
								73,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "Founded as Context Sales Sweden",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.145,
								129.947,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-58,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"sz": [
											142,
											146.5
										],
										"ps": [
											-71,
											-73.25
										],
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "Founded as Context Sales Sweden",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -8,
					"op": 610,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "2018",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 0,
									"s": [
										259
									]
								},
								{
									"t": 599,
									"s": [
										80
									]
								}
							],
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.023,
								138.085,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-3,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								55.865,
								55.865,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "n",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										],
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										]
									],
									"o": [
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										],
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										]
									],
									"v": [
										[
											-0.121,
											-184.085
										],
										[
											-180.023,
											-4.182
										],
										[
											-0.121,
											175.72
										],
										[
											179.782,
											-4.182
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 67,
										"f": "LabilGrotesk-Bold",
										"t": "2018",
										"j": 2,
										"tr": 0,
										"lh": 80.4,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {
							"m": 0,
							"f": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"l": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"a": 0,
							"p": 1,
							"r": 1
						},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -4,
					"op": 653,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "Höger ram 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"s": true,
							"x": {
								"a": 0,
								"k": 138,
								"ix": 3
							},
							"y": {
								"a": 0,
								"k": 138,
								"ix": 4
							}
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								76.427,
								76.427,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											356.336,
											356.336
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019607843,
											0.941176470588,
											0.890196078431,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"bm": 0,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": -3,
					"op": 614,
					"st": 1,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_6",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 5,
					"nm": "<empty text layer>",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								453,
								73,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "Founded as Context Sales Sweden",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.145,
								129.947,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-58,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"sz": [
											142,
											146.5
										],
										"ps": [
											-71,
											-73.25
										],
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "Founded as Context Sales Sweden",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -8,
					"op": 610,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "2019",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 0,
									"s": [
										279
									]
								},
								{
									"t": 599,
									"s": [
										100
									]
								}
							],
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.023,
								138.085,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-3,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								55.865,
								55.865,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "n",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										],
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										]
									],
									"o": [
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										],
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										]
									],
									"v": [
										[
											-0.121,
											-184.085
										],
										[
											-180.023,
											-4.182
										],
										[
											-0.121,
											175.72
										],
										[
											179.782,
											-4.182
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 67,
										"f": "LabilGrotesk-Bold",
										"t": "2019",
										"j": 2,
										"tr": 0,
										"lh": 80.4,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {
							"m": 0,
							"f": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"l": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"a": 0,
							"p": 1,
							"r": 1
						},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -4,
					"op": 653,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "Höger ram 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"s": true,
							"x": {
								"a": 0,
								"k": 138,
								"ix": 3
							},
							"y": {
								"a": 0,
								"k": 138,
								"ix": 4
							}
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								76.427,
								76.427,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											356.336,
											356.336
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019607843,
											0.941176470588,
											0.890196078431,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"bm": 0,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": -3,
					"op": 614,
					"st": 1,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_7",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 5,
					"nm": "<empty text layer>",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								453,
								73,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "Founded as Context Sales Sweden",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.145,
								129.947,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-58,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"sz": [
											142,
											146.5
										],
										"ps": [
											-71,
											-73.25
										],
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "Founded as Context Sales Sweden",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -8,
					"op": 610,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "2020",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 0,
									"s": [
										299
									]
								},
								{
									"t": 599,
									"s": [
										120
									]
								}
							],
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.023,
								138.085,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-3,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								55.865,
								55.865,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "n",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										],
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										]
									],
									"o": [
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										],
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										]
									],
									"v": [
										[
											-0.121,
											-184.085
										],
										[
											-180.023,
											-4.182
										],
										[
											-0.121,
											175.72
										],
										[
											179.782,
											-4.182
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 67,
										"f": "LabilGrotesk-Bold",
										"t": "2020",
										"j": 2,
										"tr": 0,
										"lh": 80.4,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {
							"m": 0,
							"f": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"l": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"a": 0,
							"p": 1,
							"r": 1
						},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -4,
					"op": 653,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "Höger ram 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"s": true,
							"x": {
								"a": 0,
								"k": 138,
								"ix": 3
							},
							"y": {
								"a": 0,
								"k": 138,
								"ix": 4
							}
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								76.427,
								76.427,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											356.336,
											356.336
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019607843,
											0.941176470588,
											0.890196078431,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"bm": 0,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": -3,
					"op": 614,
					"st": 1,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_8",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 5,
					"nm": "<empty text layer>",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								453,
								73,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "Founded as Context Sales Sweden",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.145,
								129.947,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-58,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"sz": [
											142,
											146.5
										],
										"ps": [
											-71,
											-73.25
										],
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "Founded as Context Sales Sweden",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -8,
					"op": 610,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "2021",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 0,
									"s": [
										319
									]
								},
								{
									"t": 599,
									"s": [
										140
									]
								}
							],
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.023,
								138.085,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-3,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								55.865,
								55.865,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "n",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										],
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										]
									],
									"o": [
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										],
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										]
									],
									"v": [
										[
											-0.121,
											-184.085
										],
										[
											-180.023,
											-4.182
										],
										[
											-0.121,
											175.72
										],
										[
											179.782,
											-4.182
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 67,
										"f": "LabilGrotesk-Bold",
										"t": "2021",
										"j": 2,
										"tr": 0,
										"lh": 80.4,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {
							"m": 0,
							"f": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"l": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"a": 0,
							"p": 1,
							"r": 1
						},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -4,
					"op": 653,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "Höger ram 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"s": true,
							"x": {
								"a": 0,
								"k": 138,
								"ix": 3
							},
							"y": {
								"a": 0,
								"k": 138,
								"ix": 4
							}
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								76.427,
								76.427,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											356.336,
											356.336
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019607843,
											0.941176470588,
											0.890196078431,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"bm": 0,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": -3,
					"op": 614,
					"st": 1,
					"bm": 0
				}
			]
		},
		{
			"id": "comp_9",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 5,
					"nm": "<empty text layer>",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								453,
								73,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": 0,
					"op": 600,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 5,
					"nm": "Founded as Context Sales Sweden",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.145,
								129.947,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-58,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"sz": [
											142,
											146.5
										],
										"ps": [
											-71,
											-73.25
										],
										"s": 15,
										"f": "ABCMonumentGroteskSemi-Mono-Regular",
										"t": "Founded as Context Sales Sweden",
										"j": 2,
										"tr": 0,
										"lh": 18,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -8,
					"op": 610,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 5,
					"nm": "2022",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"t": 0,
									"s": [
										339
									]
								},
								{
									"t": 599,
									"s": [
										160
									]
								}
							],
							"ix": 10
						},
						"p": {
							"a": 0,
							"k": [
								138.023,
								138.085,
								0
							],
							"ix": 2,
							"l": 2
						},
						"a": {
							"a": 0,
							"k": [
								0,
								-3,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								55.865,
								55.865,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"hasMask": true,
					"masksProperties": [
						{
							"inv": false,
							"mode": "n",
							"pt": {
								"a": 0,
								"k": {
									"i": [
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										],
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										]
									],
									"o": [
										[
											-99.357,
											0
										],
										[
											0,
											99.357
										],
										[
											99.357,
											0
										],
										[
											0,
											-99.357
										]
									],
									"v": [
										[
											-0.121,
											-184.085
										],
										[
											-180.023,
											-4.182
										],
										[
											-0.121,
											175.72
										],
										[
											179.782,
											-4.182
										]
									],
									"c": true
								},
								"ix": 1
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 3
							},
							"x": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"nm": "Mask 1"
						}
					],
					"t": {
						"d": {
							"k": [
								{
									"s": {
										"s": 67,
										"f": "LabilGrotesk-Bold",
										"t": "2022",
										"j": 2,
										"tr": 0,
										"lh": 80.4,
										"ls": 0,
										"fc": [
											0.949,
											0.941,
											0.89
										]
									},
									"t": 0
								}
							]
						},
						"p": {
							"m": 0,
							"f": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"l": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"a": 0,
							"p": 1,
							"r": 1
						},
						"m": {
							"g": 1,
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							}
						},
						"a": []
					},
					"ip": -4,
					"op": 653,
					"st": 0,
					"bm": 0
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "Höger ram 2",
					"sr": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100,
							"ix": 11
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 10
						},
						"p": {
							"s": true,
							"x": {
								"a": 0,
								"k": 138,
								"ix": 3
							},
							"y": {
								"a": 0,
								"k": 138,
								"ix": 4
							}
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							],
							"ix": 1,
							"l": 2
						},
						"s": {
							"a": 0,
							"k": [
								76.427,
								76.427,
								100
							],
							"ix": 6,
							"l": 2
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"d": 1,
									"ty": "el",
									"s": {
										"a": 0,
										"k": [
											356.336,
											356.336
										],
										"ix": 2
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 3
									},
									"nm": "Ellipse Path 1",
									"mn": "ADBE Vector Shape - Ellipse",
									"hd": false
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											0.949019607843,
											0.941176470588,
											0.890196078431,
											1
										],
										"ix": 3
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 4
									},
									"w": {
										"a": 0,
										"k": 2,
										"ix": 5
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"bm": 0,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke",
									"hd": false
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"bm": 0,
							"ix": 1,
							"mn": "ADBE Vector Group",
							"hd": false
						}
					],
					"ip": -3,
					"op": 614,
					"st": 1,
					"bm": 0
				}
			]
		}
	],
	"fonts": {
		"list": [
			{
				"fName": "LabilGrotesk-Bold",
				"fFamily": "Labil Grotesk",
				"fStyle": "Bold",
				"ascent": 69.9996948242188
			},
			{
				"fName": "ABCMonumentGroteskSemi-Mono-Regular",
				"fFamily": "ABC Monument Grotesk Semi-Mono",
				"fStyle": "Regular",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 3,
			"ty": 0,
			"nm": "Full width",
			"refId": "comp_0",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 0,
							"s": [
								1377,
								138,
								0
							],
							"to": [
								-236.435,
								0,
								0
							],
							"ti": [
								241.786,
								0,
								0
							]
						},
						{
							"t": 518,
							"s": [
								-1057,
								138,
								0
							]
						}
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						1362,
						138,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"w": 2724,
			"h": 276,
			"ip": 0,
			"op": 519,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "2",
			"size": 67,
			"style": "Bold",
			"w": 56.9,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												13.092
											],
											[
												14.905,
												0
											],
											[
												0,
												-13.696
											],
											[
												-0.403,
												-1.913
											],
											[
												0,
												0
											],
											[
												0,
												1.813
											],
											[
												-5.74,
												0
											],
											[
												0,
												-6.546
											],
											[
												24.673,
												-16.214
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												20.343,
												-11.481
											],
											[
												0,
												-14.2
											],
											[
												-14.905,
												0
											],
											[
												0,
												2.618
											],
											[
												0,
												0
											],
											[
												-0.302,
												-1.813
											],
											[
												0,
												-6.445
											],
											[
												6.042,
												0
											],
											[
												0,
												9.769
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												3.827,
												0
											],
											[
												53.577,
												0
											],
											[
												53.577,
												-12.891
											],
											[
												24.371,
												-12.387
											],
											[
												24.371,
												-12.589
											],
											[
												54.08,
												-48.541
											],
											[
												28.702,
												-72.51
											],
											[
												3.223,
												-49.246
											],
											[
												4.028,
												-42.197
											],
											[
												19.135,
												-42.801
											],
											[
												18.631,
												-48.239
											],
											[
												28.5,
												-58.813
											],
											[
												38.571,
												-47.736
											],
											[
												3.827,
												-11.179
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "2",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "2",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "0",
			"size": 67,
			"style": "Bold",
			"w": 63.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-16.718,
												0
											],
											[
												0,
												21.954
											],
											[
												16.617,
												0
											],
											[
												0,
												-21.954
											]
										],
										"o": [
											[
												16.617,
												0
											],
											[
												0,
												-21.954
											],
											[
												-16.718,
												0
											],
											[
												0,
												21.954
											]
										],
										"v": [
											[
												31.824,
												2.014
											],
											[
												60.123,
												-35.248
											],
											[
												31.824,
												-72.51
											],
											[
												3.525,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												7.755,
												0
											],
											[
												0,
												14.401
											],
											[
												-7.755,
												0
											],
											[
												0,
												-14.401
											]
										],
										"o": [
											[
												-7.755,
												0
											],
											[
												0,
												-14.401
											],
											[
												7.755,
												0
											],
											[
												0,
												14.401
											]
										],
										"v": [
											[
												31.824,
												-11.682
											],
											[
												19.135,
												-35.248
											],
											[
												31.824,
												-58.813
											],
											[
												44.513,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "0",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "0",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "F",
			"size": 15,
			"style": "Regular",
			"w": 59.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												19.235,
												0
											],
											[
												19.235,
												-31.522
											],
											[
												50.958,
												-31.522
											],
											[
												50.958,
												-39.679
											],
											[
												19.235,
												-39.679
											],
											[
												19.235,
												-62.338
											],
											[
												54.684,
												-62.338
											],
											[
												54.684,
												-70.496
											],
											[
												10.172,
												-70.496
											],
											[
												10.172,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "F",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "F",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "o",
			"size": 15,
			"style": "Regular",
			"w": 59.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.71,
												0
											],
											[
												0,
												15.811
											],
											[
												15.408,
												0
											],
											[
												0,
												-15.308
											]
										],
										"o": [
											[
												15.106,
												0
											],
											[
												0,
												-15.207
											],
											[
												-15.61,
												0
											],
											[
												0,
												16.415
											]
										],
										"v": [
											[
												30.112,
												1.208
											],
											[
												55.188,
												-25.177
											],
											[
												30.112,
												-51.562
											],
											[
												4.935,
												-25.177
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "o",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												5.136,
												0
											],
											[
												2.417,
												2.518
											],
											[
												0,
												6.747
											],
											[
												-3.223,
												3.323
											],
											[
												-4.935,
												0
											],
											[
												-2.417,
												-2.618
											],
											[
												0,
												-6.546
											],
											[
												2.921,
												-3.323
											]
										],
										"o": [
											[
												-5.035,
												0
											],
											[
												-3.223,
												-3.323
											],
											[
												0,
												-6.747
											],
											[
												2.417,
												-2.518
											],
											[
												5.136,
												0
											],
											[
												3.021,
												3.323
											],
											[
												0,
												6.546
											],
											[
												-2.417,
												2.719
											]
										],
										"v": [
											[
												30.112,
												-5.942
											],
											[
												19.135,
												-9.769
											],
											[
												14.703,
												-25.177
											],
											[
												19.135,
												-40.585
											],
											[
												30.112,
												-44.412
											],
											[
												41.19,
												-40.283
											],
											[
												45.419,
												-25.177
											],
											[
												41.29,
												-10.172
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "o",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "o",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "u",
			"size": 15,
			"style": "Regular",
			"w": 59,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												4.532,
												0
											],
											[
												2.921,
												2.82
											],
											[
												0,
												4.633
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.028,
												-4.23
											],
											[
												-6.546,
												0
											],
											[
												-2.719,
												5.74
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												14.603
											],
											[
												-2.921,
												0
											],
											[
												-3.021,
												-2.921
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												5.136
											],
											[
												3.625,
												3.827
											],
											[
												7.15,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												42.197,
												-22.055
											],
											[
												29.205,
												-6.345
											],
											[
												20.041,
												-9.265
											],
											[
												17.12,
												-20.746
											],
											[
												17.12,
												-50.354
											],
											[
												7.755,
												-50.354
											],
											[
												7.755,
												-20.242
											],
											[
												11.783,
												-4.431
											],
											[
												26.688,
												1.208
											],
											[
												42.197,
												-7.553
											],
											[
												42.197,
												0
											],
											[
												51.26,
												0
											],
											[
												51.26,
												-50.354
											],
											[
												42.197,
												-50.354
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "u",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "u",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "n",
			"size": 15,
			"style": "Regular",
			"w": 59,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.928,
												4.129
											],
											[
												6.647,
												0
											],
											[
												2.518,
												-5.64
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.431,
												0
											],
											[
												-2.82,
												-2.82
											],
											[
												0,
												-4.633
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.625,
												-3.827
											],
											[
												-8.057,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-14.401
											],
											[
												2.82,
												0
											],
											[
												3.122,
												2.921
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-4.935
											]
										],
										"v": [
											[
												47.937,
												-45.923
											],
											[
												32.932,
												-51.562
											],
											[
												17.422,
												-42.7
											],
											[
												17.422,
												-50.354
											],
											[
												8.359,
												-50.354
											],
											[
												8.359,
												0
											],
											[
												17.422,
												0
											],
											[
												17.422,
												-27.795
											],
											[
												30.515,
												-44.009
											],
											[
												39.478,
												-41.089
											],
											[
												42.499,
												-29.407
											],
											[
												42.499,
												0
											],
											[
												51.865,
												0
											],
											[
												51.865,
												-29.91
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "n",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "n",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "d",
			"size": 15,
			"style": "Regular",
			"w": 60.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												7.05,
												0
											],
											[
												0,
												-15.912
											],
											[
												-13.394,
												0
											],
											[
												-3.726,
												5.74
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.827,
												-5.338
											],
											[
												-13.596,
												0
											],
											[
												0,
												16.415
											],
											[
												6.747,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												43.607,
												-43.808
											],
											[
												27.393,
												-51.562
											],
											[
												4.532,
												-25.177
											],
											[
												27.695,
												1.208
											],
											[
												43.607,
												-7.352
											],
											[
												43.607,
												0
											],
											[
												52.67,
												0
											],
											[
												52.67,
												-70.496
											],
											[
												43.607,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "d",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												2.82,
												-3.223
											],
											[
												4.431,
												0
											],
											[
												0,
												11.783
											],
											[
												-2.518,
												3.323
											],
											[
												-5.64,
												0
											],
											[
												0,
												-9.366
											]
										],
										"o": [
											[
												-2.417,
												2.719
											],
											[
												-11.783,
												0
											],
											[
												0,
												-6.143
											],
											[
												2.316,
												-3.122
											],
											[
												12.286,
												0
											],
											[
												0,
												6.747
											]
										],
										"v": [
											[
												39.578,
												-10.071
											],
											[
												29.306,
												-5.942
											],
											[
												14.502,
												-25.177
											],
											[
												17.926,
												-39.478
											],
											[
												29.507,
												-44.312
											],
											[
												43.909,
												-25.076
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "d",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "d",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "e",
			"size": 15,
			"style": "Regular",
			"w": 58.5,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.021,
												4.834
											],
											[
												7.956,
												0
											],
											[
												4.431,
												-5.035
											],
											[
												0,
												-7.452
											],
											[
												-4.23,
												-4.733
											],
											[
												-7.755,
												0
											],
											[
												-2.216,
												11.783
											],
											[
												0,
												0
											],
											[
												8.56,
												0
											],
											[
												0.201,
												11.078
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-4.129,
												-6.546
											],
											[
												-7.251,
												0
											],
											[
												-4.23,
												4.733
											],
											[
												0,
												7.855
											],
											[
												4.33,
												5.035
											],
											[
												12.79,
												0
											],
											[
												0,
												0
											],
											[
												-1.208,
												7.654
											],
											[
												-9.467,
												0
											],
											[
												0,
												0
											],
											[
												0.403,
												-7.15
											]
										],
										"v": [
											[
												49.347,
												-41.592
											],
											[
												29.709,
												-51.562
											],
											[
												11.884,
												-44.009
											],
											[
												5.539,
												-25.278
											],
											[
												11.682,
												-6.143
											],
											[
												29.81,
												1.208
											],
											[
												52.872,
												-16.617
											],
											[
												44.11,
												-17.322
											],
											[
												29.709,
												-6.042
											],
											[
												15.408,
												-22.458
											],
											[
												53.577,
												-22.458
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "e",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-5.64,
												0
											],
											[
												-2.618,
												-3.827
											],
											[
												-0.101,
												-2.719
											],
											[
												0,
												0
											],
											[
												-1.813,
												3.021
											]
										],
										"o": [
											[
												5.438,
												0
											],
											[
												1.611,
												2.417
											],
											[
												0,
												0
											],
											[
												0,
												-2.518
											],
											[
												2.014,
												-3.323
											]
										],
										"v": [
											[
												29.81,
												-44.211
											],
											[
												41.592,
												-38.773
											],
											[
												44.312,
												-29.81
											],
											[
												15.509,
												-29.81
											],
											[
												17.926,
												-38.773
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "e",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "e",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": " ",
			"size": 15,
			"style": "Regular",
			"w": 42.2,
			"data": {},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "a",
			"size": 15,
			"style": "Regular",
			"w": 58,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0.806,
												0
											],
											[
												0,
												2.618
											],
											[
												0,
												0
											],
											[
												12.689,
												0
											],
											[
												3.625,
												-2.417
											],
											[
												0.201,
												-6.042
											],
											[
												0,
												0
											],
											[
												-8.762,
												0
											],
											[
												-1.41,
												-2.014
											],
											[
												0,
												-4.532
											],
											[
												0,
												0
											],
											[
												0,
												-10.876
											],
											[
												-8.459,
												0
											],
											[
												-2.82,
												5.74
											],
											[
												-5.539,
												0
											],
											[
												-1.913,
												0.302
											]
										],
										"o": [
											[
												-1.309,
												0.302
											],
											[
												-2.921,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-10.977
											],
											[
												-6.445,
												0
											],
											[
												-3.928,
												2.618
											],
											[
												0,
												0
											],
											[
												0,
												-7.654
											],
											[
												4.431,
												0
											],
											[
												1.511,
												2.115
											],
											[
												0,
												0
											],
											[
												-7.956,
												1.511
											],
											[
												0,
												9.869
											],
											[
												8.56,
												0
											],
											[
												0.504,
												5.237
											],
											[
												2.014,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												54.886,
												-7.452
											],
											[
												51.965,
												-7.05
											],
											[
												49.045,
												-10.876
											],
											[
												49.045,
												-34.946
											],
											[
												29.91,
												-51.562
											],
											[
												14.502,
												-47.836
											],
											[
												8.258,
												-34.744
											],
											[
												17.12,
												-33.536
											],
											[
												29.407,
												-44.412
											],
											[
												38.571,
												-41.089
											],
											[
												40.283,
												-31.924
											],
											[
												23.666,
												-28.702
											],
											[
												6.546,
												-13.293
											],
											[
												23.465,
												1.208
											],
											[
												40.384,
												-7.452
											],
											[
												49.448,
												0.403
											],
											[
												55.087,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "a",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												10.977,
												0
											],
											[
												0,
												4.733
											],
											[
												-5.338,
												1.208
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-4.935,
												0
											],
											[
												0,
												-5.74
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												7.251
											]
										],
										"v": [
											[
												24.875,
												-6.042
											],
											[
												15.811,
												-13.394
											],
											[
												25.076,
												-21.854
											],
											[
												40.283,
												-25.177
											],
											[
												40.283,
												-19.034
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "a",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "a",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "s",
			"size": 15,
			"style": "Regular",
			"w": 55.4,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-11.279,
												0
											],
											[
												0,
												12.286
											],
											[
												10.071,
												2.115
											],
											[
												0,
												4.633
											],
											[
												-4.935,
												0
											],
											[
												-0.201,
												-6.949
											],
											[
												0,
												0
											],
											[
												10.675,
												0
											],
											[
												0,
												-10.474
											],
											[
												-8.157,
												-2.115
											],
											[
												0,
												-5.74
											],
											[
												8.258,
												0
											],
											[
												-0.101,
												7.05
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												10.172,
												0
											],
											[
												0,
												-11.783
											],
											[
												-6.042,
												-1.309
											],
											[
												0,
												-4.633
											],
											[
												7.956,
												0
											],
											[
												0,
												0
											],
											[
												-1.108,
												-12.286
											],
											[
												-8.963,
												0
											],
											[
												0,
												9.97
											],
											[
												6.949,
												1.813
											],
											[
												0,
												5.338
											],
											[
												-7.855,
												0
											],
											[
												0,
												0
											],
											[
												-0.101,
												12.488
											]
										],
										"v": [
											[
												28.299,
												1.208
											],
											[
												49.045,
												-14.603
											],
											[
												28.601,
												-30.212
											],
											[
												16.516,
												-37.463
											],
											[
												26.587,
												-44.412
											],
											[
												39.276,
												-33.737
											],
											[
												47.736,
												-35.046
											],
											[
												26.688,
												-51.562
											],
											[
												8.057,
												-36.859
											],
											[
												24.271,
												-22.357
											],
											[
												40.485,
												-14.099
											],
											[
												28.098,
												-5.942
											],
											[
												15.207,
												-17.322
											],
											[
												6.949,
												-16.516
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "s",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "s",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "C",
			"size": 15,
			"style": "Regular",
			"w": 66.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-19.537,
												0
											],
											[
												-5.136,
												12.991
											],
											[
												0,
												0
											],
											[
												9.769,
												0
											],
											[
												3.223,
												4.532
											],
											[
												0,
												9.366
											],
											[
												-3.726,
												4.935
											],
											[
												-6.647,
												0
											],
											[
												-1.913,
												-8.661
											],
											[
												0,
												0
											],
											[
												13.293,
												0
											],
											[
												0,
												-21.35
											]
										],
										"o": [
											[
												13.596,
												0
											],
											[
												0,
												0
											],
											[
												-2.719,
												8.157
											],
											[
												-6.848,
												0
											],
											[
												-3.525,
												-5.035
											],
											[
												0,
												-9.567
											],
											[
												3.424,
												-4.633
											],
											[
												10.172,
												0
											],
											[
												0,
												0
											],
											[
												-3.525,
												-14.301
											],
											[
												-20.142,
												0
											],
											[
												0,
												23.566
											]
										],
										"v": [
											[
												35.248,
												1.208
											],
											[
												63.345,
												-18.43
											],
											[
												53.174,
												-21.048
											],
											[
												35.349,
												-6.647
											],
											[
												20.041,
												-13.596
											],
											[
												15.308,
												-35.248
											],
											[
												20.444,
												-57.202
											],
											[
												35.651,
												-63.849
											],
											[
												53.073,
												-48.239
											],
											[
												62.943,
												-50.153
											],
											[
												35.449,
												-71.704
											],
											[
												5.035,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "C",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "C",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "t",
			"size": 15,
			"style": "Regular",
			"w": 46.4,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-10.876,
												0
											],
											[
												-1.913,
												0.504
											],
											[
												0,
												0
											],
											[
												1.913,
												0
											],
											[
												0,
												4.028
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												2.618,
												0
											],
											[
												0,
												0
											],
											[
												-2.014,
												0.504
											],
											[
												-5.438,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.164
											]
										],
										"v": [
											[
												32.025,
												0.504
											],
											[
												39.478,
												-0.302
											],
											[
												39.276,
												-8.56
											],
											[
												32.73,
												-7.654
											],
											[
												25.378,
												-12.689
											],
											[
												25.378,
												-42.801
											],
											[
												39.679,
												-42.801
											],
											[
												39.679,
												-50.354
											],
											[
												25.378,
												-50.354
											],
											[
												25.378,
												-64.352
											],
											[
												16.415,
												-64.352
											],
											[
												16.415,
												-50.354
											],
											[
												5.841,
												-50.354
											],
											[
												5.841,
												-42.801
											],
											[
												16.415,
												-42.801
											],
											[
												16.415,
												-12.387
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "t",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "t",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "x",
			"size": 15,
			"style": "Regular",
			"w": 55.4,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.108,
												-1.611
											],
											[
												1.712,
												2.417
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.309,
												2.014
											],
											[
												-1.813,
												-2.618
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.712,
												2.417
											],
											[
												-1.007,
												-1.611
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												2.417,
												-3.424
											],
											[
												1.309,
												2.115
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												49.85,
												-50.354
											],
											[
												39.981,
												-50.354
											],
											[
												32.025,
												-38.974
											],
											[
												27.695,
												-32.428
											],
											[
												23.465,
												-38.974
											],
											[
												15.308,
												-50.354
											],
											[
												5.539,
												-50.354
											],
											[
												22.961,
												-26.285
											],
											[
												4.028,
												0
											],
											[
												13.797,
												0
											],
											[
												22.156,
												-11.884
											],
											[
												27.695,
												-20.444
											],
											[
												33.133,
												-11.884
											],
											[
												41.492,
												0
											],
											[
												51.26,
												0
											],
											[
												32.327,
												-26.285
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "x",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "x",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "S",
			"size": 15,
			"style": "Regular",
			"w": 63,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.106,
												0
											],
											[
												0,
												17.12
											],
											[
												13.495,
												2.316
											],
											[
												0,
												8.057
											],
											[
												-7.452,
												0
											],
											[
												-0.403,
												-10.172
											],
											[
												0,
												0
											],
											[
												13.898,
												0
											],
											[
												0,
												-14.301
											],
											[
												-10.574,
												-2.518
											],
											[
												0,
												-9.769
											],
											[
												9.567,
												0
											],
											[
												0.302,
												10.977
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												12.891,
												0
											],
											[
												0,
												-14.804
											],
											[
												-9.164,
												-1.611
											],
											[
												0,
												-7.956
											],
											[
												10.574,
												0
											],
											[
												0,
												0
											],
											[
												-1.611,
												-16.315
											],
											[
												-11.279,
												0
											],
											[
												0,
												13.293
											],
											[
												10.172,
												2.518
											],
											[
												0,
												9.97
											],
											[
												-10.474,
												0
											],
											[
												0,
												0
											],
											[
												0.302,
												16.113
											]
										],
										"v": [
											[
												32.529,
												1.208
											],
											[
												59.72,
												-20.544
											],
											[
												34.744,
												-40.283
											],
											[
												15.408,
												-52.267
											],
											[
												30.515,
												-64.151
											],
											[
												48.038,
												-48.038
											],
											[
												57.504,
												-49.75
											],
											[
												30.414,
												-71.704
											],
											[
												6.042,
												-51.865
											],
											[
												28.198,
												-32.025
											],
											[
												50.253,
												-19.839
											],
											[
												32.227,
												-6.445
											],
											[
												13.696,
												-23.465
											],
											[
												4.028,
												-22.458
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "S",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "S",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "l",
			"size": 15,
			"style": "Regular",
			"w": 42.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.486,
												-70.496
											],
											[
												9.064,
												-70.496
											],
											[
												9.064,
												-62.842
											],
											[
												17.422,
												-62.842
											],
											[
												17.422,
												-7.654
											],
											[
												7.352,
												-7.654
											],
											[
												7.352,
												0
											],
											[
												35.651,
												0
											],
											[
												35.651,
												-7.654
											],
											[
												26.486,
												-7.654
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "l",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "l",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "w",
			"size": 15,
			"style": "Regular",
			"w": 67.5,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.806,
												4.733
											],
											[
												0,
												0
											],
											[
												-0.504,
												-1.913
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.208,
												-6.143
											],
											[
												0,
												0
											],
											[
												0.806,
												3.323
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0.906,
												-4.33
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0.806,
												-3.323
											],
											[
												0,
												0
											],
											[
												0.906,
												5.035
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.906,
												4.028
											],
											[
												0,
												0
											],
											[
												-0.906,
												-5.136
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.604,
												2.417
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												25.378,
												0
											],
											[
												31.018,
												-22.458
											],
											[
												33.838,
												-35.751
											],
											[
												34.039,
												-35.751
											],
											[
												36.859,
												-22.458
											],
											[
												42.7,
												0
											],
											[
												52.67,
												0
											],
											[
												65.964,
												-50.354
											],
											[
												56.396,
												-50.354
											],
											[
												50.354,
												-23.465
											],
											[
												47.433,
												-8.762
											],
											[
												47.232,
												-8.762
											],
											[
												44.11,
												-23.465
											],
											[
												38.269,
												-46.829
											],
											[
												29.709,
												-46.829
											],
											[
												23.868,
												-23.465
											],
											[
												20.544,
												-8.762
											],
											[
												20.343,
												-8.762
											],
											[
												17.422,
												-23.465
											],
											[
												11.682,
												-50.354
											],
											[
												2.014,
												-50.354
											],
											[
												15.308,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "w",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "w",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "1",
			"size": 67,
			"style": "Bold",
			"w": 38.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												10.574,
												0.101
											],
											[
												0,
												0
											],
											[
												-2.417,
												3.928
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-0.101,
												8.56
											],
											[
												0,
												0
											],
											[
												6.949,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												18.631,
												0
											],
											[
												34.039,
												0
											],
											[
												34.039,
												-70.999
											],
											[
												20.444,
												-70.999
											],
											[
												2.518,
												-56.699
											],
											[
												2.518,
												-44.211
											],
											[
												18.329,
												-50.656
											],
											[
												18.631,
												-50.656
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "1",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "1",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "9",
			"size": 67,
			"style": "Bold",
			"w": 59.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												17.02,
												0
											],
											[
												0,
												-13.998
											],
											[
												-14.301,
												0
											],
											[
												-1.611,
												4.935
											],
											[
												0,
												0
											],
											[
												0,
												-0.806
											],
											[
												8.057,
												0
											],
											[
												0.403,
												6.345
											],
											[
												0,
												0
											],
											[
												-14.502,
												0
											],
											[
												0,
												23.666
											]
										],
										"o": [
											[
												-15.408,
												0
											],
											[
												0,
												13.696
											],
											[
												7.251,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0.705
											],
											[
												0,
												13.293
											],
											[
												-6.143,
												0
											],
											[
												0,
												0
											],
											[
												0.504,
												13.797
											],
											[
												17.12,
												0
											],
											[
												0,
												-21.249
											]
										],
										"v": [
											[
												29.407,
												-72.51
											],
											[
												3.223,
												-48.843
											],
											[
												27.393,
												-25.58
											],
											[
												42.297,
												-34.14
											],
											[
												42.7,
												-34.14
											],
											[
												42.801,
												-31.522
											],
											[
												30.313,
												-10.876
											],
											[
												19.135,
												-21.35
											],
											[
												4.532,
												-21.048
											],
											[
												29.91,
												2.014
											],
											[
												57.706,
												-36.154
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "9",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-6.345,
												0
											],
											[
												0,
												-6.848
											],
											[
												6.345,
												0
											],
											[
												0,
												6.848
											]
										],
										"o": [
											[
												6.345,
												0
											],
											[
												0,
												6.747
											],
											[
												-6.345,
												0
											],
											[
												0,
												-6.848
											]
										],
										"v": [
											[
												29.407,
												-60.526
											],
											[
												40.082,
												-48.743
											],
											[
												29.407,
												-37.262
											],
											[
												18.631,
												-48.843
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "9",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "9",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "8",
			"size": 67,
			"style": "Bold",
			"w": 59.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.811,
												0
											],
											[
												0,
												11.984
											],
											[
												8.157,
												2.316
											],
											[
												0,
												0
											],
											[
												0,
												7.654
											],
											[
												15.207,
												0
											],
											[
												0,
												-12.286
											],
											[
												-7.352,
												-1.813
											],
											[
												0,
												0
											],
											[
												0,
												-7.654
											]
										],
										"o": [
											[
												15.811,
												0
											],
											[
												0,
												-7.654
											],
											[
												0,
												0
											],
											[
												7.352,
												-1.813
											],
											[
												0,
												-12.286
											],
											[
												-15.106,
												0
											],
											[
												0,
												7.654
											],
											[
												0,
												0
											],
											[
												-8.057,
												2.316
											],
											[
												0,
												11.984
											]
										],
										"v": [
											[
												30.112,
												2.014
											],
											[
												57.001,
												-18.228
											],
											[
												43.204,
												-35.147
											],
											[
												43.204,
												-35.449
											],
											[
												55.792,
												-51.562
											],
											[
												30.112,
												-72.51
											],
											[
												4.532,
												-51.562
											],
											[
												17.02,
												-35.449
											],
											[
												17.02,
												-35.147
											],
											[
												3.323,
												-18.228
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "8",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												6.244,
												0
											],
											[
												0,
												5.539
											],
											[
												-6.244,
												0
											],
											[
												0,
												-5.539
											]
										],
										"o": [
											[
												-6.244,
												0
											],
											[
												0,
												-5.539
											],
											[
												6.244,
												0
											],
											[
												0,
												5.539
											]
										],
										"v": [
											[
												30.112,
												-40.988
											],
											[
												19.537,
												-50.354
											],
											[
												30.112,
												-59.619
											],
											[
												40.686,
												-50.354
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "8",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 2,
								"ty": "sh",
								"ix": 3,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												6.747,
												0
											],
											[
												0,
												5.539
											],
											[
												-6.747,
												0
											],
											[
												0,
												-5.539
											]
										],
										"o": [
											[
												-6.747,
												0
											],
											[
												0,
												-5.539
											],
											[
												6.747,
												0
											],
											[
												0,
												5.539
											]
										],
										"v": [
											[
												30.112,
												-10.977
											],
											[
												18.732,
												-20.343
											],
											[
												30.112,
												-29.81
											],
											[
												41.592,
												-20.343
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "8",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "8",
						"np": 6,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "7",
			"size": 67,
			"style": "Bold",
			"w": 55.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												-23.364
											],
											[
												0,
												0
											],
											[
												-13.696,
												12.991
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												-22.961
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-15.61,
												11.884
											]
										],
										"v": [
											[
												15.106,
												0
											],
											[
												30.917,
												0
											],
											[
												53.073,
												-58.511
											],
											[
												53.073,
												-70.496
											],
											[
												2.618,
												-70.496
											],
											[
												2.618,
												-57.605
											],
											[
												40.182,
												-57.605
											],
											[
												40.182,
												-57.303
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "7",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "7",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "6",
			"size": 67,
			"style": "Bold",
			"w": 59.8,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-17.02,
												0
											],
											[
												0,
												13.998
											],
											[
												14.301,
												0
											],
											[
												1.611,
												-4.935
											],
											[
												0,
												0
											],
											[
												0,
												0.806
											],
											[
												-7.956,
												0
											],
											[
												-0.403,
												-6.345
											],
											[
												0,
												0
											],
											[
												14.502,
												0
											],
											[
												0,
												-23.666
											]
										],
										"o": [
											[
												15.408,
												0
											],
											[
												0,
												-13.696
											],
											[
												-7.251,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-0.705
											],
											[
												0,
												-13.293
											],
											[
												6.143,
												0
											],
											[
												0,
												0
											],
											[
												-0.504,
												-13.797
											],
											[
												-17.12,
												0
											],
											[
												0,
												21.249
											]
										],
										"v": [
											[
												31.824,
												2.014
											],
											[
												58.008,
												-21.652
											],
											[
												33.838,
												-44.916
											],
											[
												18.933,
												-36.356
											],
											[
												18.53,
												-36.356
											],
											[
												18.43,
												-38.974
											],
											[
												30.917,
												-59.619
											],
											[
												42.096,
												-49.146
											],
											[
												56.699,
												-49.448
											],
											[
												31.32,
												-72.51
											],
											[
												3.525,
												-34.341
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "6",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												6.345,
												0
											],
											[
												0,
												6.848
											],
											[
												-6.345,
												0
											],
											[
												0,
												-6.848
											]
										],
										"o": [
											[
												-6.345,
												0
											],
											[
												0,
												-6.747
											],
											[
												6.345,
												0
											],
											[
												0,
												6.848
											]
										],
										"v": [
											[
												31.824,
												-9.97
											],
											[
												21.149,
												-21.753
											],
											[
												31.824,
												-33.234
											],
											[
												42.599,
												-21.652
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "6",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "6",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "5",
			"size": 67,
			"style": "Bold",
			"w": 58.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.408,
												0
											],
											[
												0,
												14.603
											],
											[
												13.092,
												0
											],
											[
												3.021,
												-2.921
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.129,
												0
											],
											[
												0,
												-6.949
											],
											[
												6.445,
												0
											],
											[
												0.302,
												6.042
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												15.61,
												0
											],
											[
												0,
												-13.998
											],
											[
												-5.338,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												1.511,
												-3.525
											],
											[
												6.546,
												0
											],
											[
												0,
												6.949
											],
											[
												-6.143,
												0
											],
											[
												0,
												0
											],
											[
												0.101,
												13.293
											]
										],
										"v": [
											[
												28.903,
												2.014
											],
											[
												55.389,
												-22.659
											],
											[
												32.73,
												-46.326
											],
											[
												19.638,
												-41.492
											],
											[
												19.336,
												-41.492
											],
											[
												21.149,
												-57.605
											],
											[
												53.577,
												-57.605
											],
											[
												53.577,
												-70.496
											],
											[
												8.459,
												-70.496
											],
											[
												3.827,
												-30.716
											],
											[
												19.437,
												-28.5
											],
											[
												28.903,
												-34.341
											],
											[
												39.981,
												-22.659
											],
											[
												29.004,
												-10.876
											],
											[
												18.127,
												-21.048
											],
											[
												2.719,
												-20.544
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "5",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "5",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "i",
			"size": 15,
			"style": "Regular",
			"w": 42.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												16.617,
												-70.596
											],
											[
												16.617,
												-59.72
											],
											[
												25.882,
												-59.72
											],
											[
												25.882,
												-70.596
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "i",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.285,
												-50.354
											],
											[
												8.661,
												-50.354
											],
											[
												8.661,
												-42.7
											],
											[
												17.221,
												-42.7
											],
											[
												17.221,
												-7.654
											],
											[
												7.15,
												-7.654
											],
											[
												7.15,
												0
											],
											[
												35.449,
												0
											],
											[
												35.449,
												-7.654
											],
											[
												26.285,
												-7.654
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "i",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "i",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "r",
			"size": 15,
			"style": "Regular",
			"w": 48.7,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0.906,
												-0.101
											],
											[
												1.913,
												-5.64
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-10.373,
												0
											],
											[
												-0.806,
												-0.101
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-8.862,
												0.806
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-16.617
											],
											[
												1.108,
												0
											],
											[
												0,
												0
											],
											[
												-0.906,
												0
											]
										],
										"v": [
											[
												39.377,
												-51.462
											],
											[
												21.652,
												-40.887
											],
											[
												21.652,
												-50.354
											],
											[
												12.589,
												-50.354
											],
											[
												12.589,
												0
											],
											[
												21.652,
												0
											],
											[
												21.652,
												-23.062
											],
											[
												40.182,
												-43.103
											],
											[
												43.304,
												-43.002
											],
											[
												43.506,
												-51.562
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "r",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "r",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "c",
			"size": 15,
			"style": "Regular",
			"w": 57.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.408,
												0
											],
											[
												-1.813,
												10.172
											],
											[
												0,
												0
											],
											[
												7.755,
												0
											],
											[
												0,
												11.38
											],
											[
												-2.518,
												3.424
											],
											[
												-5.74,
												0
											],
											[
												-1.511,
												-5.841
											],
											[
												0,
												0
											],
											[
												12.79,
												0
											],
											[
												0,
												-15.509
											]
										],
										"o": [
											[
												11.682,
												0
											],
											[
												0,
												0
											],
											[
												-1.913,
												7.251
											],
											[
												-12.186,
												0
											],
											[
												0,
												-5.942
											],
											[
												2.316,
												-3.021
											],
											[
												9.064,
												0
											],
											[
												0,
												0
											],
											[
												-2.014,
												-9.567
											],
											[
												-15.408,
												0
											],
											[
												0,
												16.516
											]
										],
										"v": [
											[
												30.917,
												1.208
											],
											[
												53.174,
												-15.408
											],
											[
												44.614,
												-16.315
											],
											[
												30.917,
												-6.042
											],
											[
												15.912,
												-25.177
											],
											[
												19.235,
												-39.578
											],
											[
												30.917,
												-44.312
											],
											[
												44.513,
												-32.73
											],
											[
												52.972,
												-34.341
											],
											[
												30.917,
												-51.562
											],
											[
												5.942,
												-25.177
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "c",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "c",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "p",
			"size": 15,
			"style": "Regular",
			"w": 60.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												13.394,
												0
											],
											[
												3.726,
												-5.74
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-7.05,
												0
											],
											[
												0,
												15.912
											]
										],
										"o": [
											[
												-6.747,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												3.827,
												5.338
											],
											[
												13.596,
												0
											],
											[
												0,
												-16.415
											]
										],
										"v": [
											[
												33.133,
												-51.562
											],
											[
												17.221,
												-43.002
											],
											[
												17.221,
												-50.354
											],
											[
												8.157,
												-50.354
											],
											[
												8.157,
												20.142
											],
											[
												17.221,
												20.142
											],
											[
												17.221,
												-6.546
											],
											[
												33.435,
												1.208
											],
											[
												56.296,
												-25.177
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "p",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												2.82,
												-3.122
											],
											[
												5.136,
												0
											],
											[
												0,
												9.366
											],
											[
												-2.618,
												3.223
											],
											[
												-4.633,
												0
											],
											[
												0,
												-11.783
											]
										],
										"o": [
											[
												-2.316,
												2.82
											],
											[
												-12.286,
												0
											],
											[
												0,
												-6.546
											],
											[
												2.417,
												-3.021
											],
											[
												11.783,
												0
											],
											[
												0,
												6.445
											]
										],
										"v": [
											[
												42.398,
												-10.373
											],
											[
												31.32,
												-6.042
											],
											[
												16.919,
												-25.278
											],
											[
												20.847,
												-39.88
											],
											[
												31.522,
												-44.412
											],
											[
												46.326,
												-25.177
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "p",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "p",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "g",
			"size": 15,
			"style": "Regular",
			"w": 60,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												7.553,
												0
											],
											[
												0,
												-14.905
											],
											[
												-13.898,
												0
											],
											[
												-3.726,
												5.841
											],
											[
												0,
												0
											],
											[
												8.157,
												0
											],
											[
												0.403,
												8.359
											],
											[
												0,
												0
											],
											[
												-9.97,
												0
											],
											[
												0,
												13.495
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.525,
												-5.338
											],
											[
												-13.495,
												0
											],
											[
												0,
												15.71
											],
											[
												6.949,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.164
											],
											[
												-8.057,
												0
											],
											[
												0,
												0
											],
											[
												0.504,
												12.689
											],
											[
												14.804,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												44.009,
												-43.304
											],
											[
												27.795,
												-51.562
											],
											[
												5.035,
												-26.486
											],
											[
												28.098,
												-0.403
											],
											[
												44.009,
												-9.064
											],
											[
												44.009,
												-0.504
											],
											[
												29.91,
												13.596
											],
											[
												16.113,
												3.021
											],
											[
												7.452,
												3.625
											],
											[
												28.903,
												20.645
											],
											[
												53.073,
												-1.108
											],
											[
												53.073,
												-50.354
											],
											[
												44.009,
												-50.354
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "g",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.323,
												-3.625
											],
											[
												4.733,
												0
											],
											[
												0,
												11.783
											],
											[
												-2.82,
												3.021
											],
											[
												-5.136,
												0
											],
											[
												0,
												-11.884
											]
										],
										"o": [
											[
												-2.316,
												2.518
											],
											[
												-11.581,
												0
											],
											[
												0,
												-5.942
											],
											[
												2.316,
												-2.719
											],
											[
												9.467,
												0
											],
											[
												0,
												5.438
											]
										],
										"v": [
											[
												39.88,
												-11.783
											],
											[
												29.507,
												-7.654
											],
											[
												14.905,
												-26.486
											],
											[
												18.732,
												-40.182
											],
											[
												29.709,
												-44.312
											],
											[
												44.412,
												-26.486
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "g",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "g",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "f",
			"size": 15,
			"style": "Regular",
			"w": 46,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-5.035,
												0
											],
											[
												-1.913,
												-0.403
											],
											[
												0,
												0
											],
											[
												2.82,
												0
											],
											[
												0,
												-8.157
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.323
											],
											[
												1.913,
												0
											],
											[
												0,
												0
											],
											[
												-1.309,
												-0.302
											],
											[
												-10.977,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.385,
												0
											],
											[
												26.385,
												-42.801
											],
											[
												40.686,
												-42.801
											],
											[
												40.686,
												-50.354
											],
											[
												26.385,
												-50.354
											],
											[
												26.385,
												-58.713
											],
											[
												33.636,
												-62.943
											],
											[
												39.981,
												-62.338
											],
											[
												40.182,
												-70.395
											],
											[
												33.133,
												-70.999
											],
											[
												17.422,
												-58.914
											],
											[
												17.422,
												-50.354
											],
											[
												6.848,
												-50.354
											],
											[
												6.848,
												-42.801
											],
											[
												17.422,
												-42.801
											],
											[
												17.422,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "f",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "f",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "h",
			"size": 15,
			"style": "Regular",
			"w": 59,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.928,
												4.129
											],
											[
												6.647,
												0
											],
											[
												2.82,
												-6.042
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.532,
												0
											],
											[
												-2.82,
												-2.82
											],
											[
												0,
												-4.633
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.625,
												-3.827
											],
											[
												-7.05,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-14.603
											],
											[
												2.82,
												0
											],
											[
												3.122,
												2.921
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-4.834
											]
										],
										"v": [
											[
												47.937,
												-45.923
											],
											[
												32.932,
												-51.562
											],
											[
												17.422,
												-42.801
											],
											[
												17.422,
												-70.496
											],
											[
												8.359,
												-70.496
											],
											[
												8.359,
												0
											],
											[
												17.422,
												0
											],
											[
												17.422,
												-28.299
											],
											[
												30.515,
												-44.009
											],
											[
												39.478,
												-41.089
											],
											[
												42.499,
												-29.608
											],
											[
												42.499,
												0
											],
											[
												51.865,
												0
											],
											[
												51.865,
												-30.112
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "h",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "h",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "v",
			"size": 15,
			"style": "Regular",
			"w": 55.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												2.014,
												-6.345
											],
											[
												0.906,
												2.618
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.712,
												5.035
											],
											[
												-2.417,
												-8.057
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												32.629,
												0
											],
											[
												51.462,
												-50.354
											],
											[
												41.995,
												-50.354
											],
											[
												32.932,
												-24.271
											],
											[
												27.795,
												-8.359
											],
											[
												22.76,
												-24.271
											],
											[
												13.797,
												-50.354
											],
											[
												4.129,
												-50.354
											],
											[
												22.961,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "v",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "v",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/Timeline_desktop_mobile.json
// module id = 71
// module chunks = 0